import {importSwiper} from "./kp-util";

const carousel_blocks = document.querySelectorAll('.bin-gallery-swiper')

if (carousel_blocks.length > 0) {
    importSwiper().then(({Swiper, Pagination}) => {
        carousel_blocks.forEach(block => {

            const pagination = block.querySelector('.swiper-pagination')

            new Swiper(block, {
                modules: [Pagination],
                slidesPerView: 1,
                pagination: {
                    type: "bullets",
                    el: pagination,
                    clickable: true
                }
            })
        })
    })
}

